import React, { Suspense, useEffect, useState } from 'react'
import { CpdRenewalForm } from './DataFile/CpdRenewalCycleForm.Data'
import FormCreator from '../../../components/Forms/FormCreator'
import { useRef } from 'react';
import CpdRenewalCycleTable from './component/CpdRenewalCycleTable';
import Buttons from '../../../components/ui/button/Buttons';
import { useDownloadSheetForCPDRenewalCycleMutation, useGetCPDRenewalCycleListMutation } from '../../../app/services/CPD/CPDApi';
import { useLazyGetAllDropDownsQuery } from '../../../app/services/common/commonApi';
import { setDropdownFieldsCpdRenewalCycle } from './Utils/CpdRenewalCycleUtils';
import { saveAs } from 'file-saver';
import DataLoader from '../../../components/ui/dataLoader/DataLoader';

const CpdRenewalCycleForm = () => {
    const [cpdRenewalForm, setCpdRenewalForm] = useState(CpdRenewalForm);
    const cpdRenewalref = useRef();
    const [dataSource, setDataSource] = useState();
    const [isSearched, setIsSearched] = useState(false);
    const [paginationRequest, setPaginationRequest] = useState({
        pageNo: 1,
        pageSize: 20,
        endPage: 100,
        searchText: "",
        totalCount: 0,
        appilcationType: '',
        renewalCycle: '',
        status: '',
        qualificationEndDate: ""
    });

    const [getCpdRenewalCycleList, { isSuccess, isLoading, data: cpdRenewalCycleResponse }] = useGetCPDRenewalCycleListMutation();
    const [downloadSheetForrCPDRenewalCycle,{ isSuccess: isDownloadSheetForrCPDRenewalCycleSuccess, isLoading: isDownloadSheetrCPDRenewalCycleFetching, data: DownloadSheetForrCPDRenewalCycleResponse }, ] = useDownloadSheetForCPDRenewalCycleMutation();
    const [getAllDropDowns, { data: allDropDownResponse, isSuccess: isGetAllDropDownSuccess, isFetching: isGetDropDownFetching, isLoading: dropdownListLoading, },] = useLazyGetAllDropDownsQuery()
    
    useEffect(() => {
        if (!isDownloadSheetrCPDRenewalCycleFetching && isDownloadSheetForrCPDRenewalCycleSuccess && DownloadSheetForrCPDRenewalCycleResponse) {
        }
    }, [isDownloadSheetrCPDRenewalCycleFetching, isDownloadSheetForrCPDRenewalCycleSuccess, DownloadSheetForrCPDRenewalCycleResponse]);

    useEffect(() => { getAllDropDowns() }, [])

    useEffect(() => {
        if (allDropDownResponse) {
            setDropdownFieldsCpdRenewalCycle(allDropDownResponse, cpdRenewalForm)
        }
    }, [dropdownListLoading, isGetDropDownFetching, isGetAllDropDownSuccess, allDropDownResponse,]);

    useEffect(() => {
        if (!isLoading && isSuccess && cpdRenewalCycleResponse) {
                        setPaginationRequest({
                ...paginationRequest,
                totalCount: cpdRenewalCycleResponse.totalCount,
            });

            const statusFields = ['renewalStatus', 'discretionaryRenewalStatus', 'upgradeStatus'];

            const formattedItemList = (cpdRenewalCycleResponse?.itemList || []).map((item) => {
                const updatedItem = { ...item };
                statusFields.forEach((field) => {
                    if (updatedItem[field] === null || updatedItem[field] === undefined || updatedItem[field] === '') {
                        updatedItem[field] = '-';
                    }
                });
                return updatedItem;
            });

            setDataSource(formattedItemList);
        }
    }, [isLoading, isSuccess, cpdRenewalCycleResponse]);

    const getCpdRenewalList = (req) => {
        getCpdRenewalCycleList({ ...paginationRequest, ...req });
    };

    const handleSearch = () => {
        if (!cpdRenewalref.current) {
            return;
        }
        const formData = cpdRenewalref.current.getFormData();
        const updatedPaginationRequest = {
            pageNo: 1,
            pageSize: 20,
            endPage: 100,
            searchText: formData.searchText || "",
            appilcationType: formData.appilcationType?.value || "",
            renewalCycle: formData.renewalCycle?.value || "",
            renewalApplicationAndPaymentStatus: formData.status?.value || "",
            qualificationEndDate: formData.qualificationEndDate?.value || "",

        };
        setPaginationRequest(updatedPaginationRequest);
        getCpdRenewalList(updatedPaginationRequest);
        setIsSearched(true)
    };

    const handleClear = () => {
        const updatedPaginationRequest = {
            pageNo: 1,
            pageSize: 20,
            endPage: 100,
            searchText: "",
            totalCount: 0,
            appilcationType: '',
            renewalCycle: '',
            status: '',
            qualificationEndDate: ""
        };
        let formData = { ...cpdRenewalForm, initialState: { searchText: '', appilcationType: '', renewalCycle: '', renewalApplicationAndPaymentStatus: '', qualificationEndDate: "" }, }
        setPaginationRequest(updatedPaginationRequest);
        getCpdRenewalList(updatedPaginationRequest);
        setIsSearched(false)
        setCpdRenewalForm(formData)
    }

    const handlePageChange = ({ pageNumber, pageSize }) => {
        getCpdRenewalList({
            ...paginationRequest,
            pageNo: pageNumber,
            pageSize: pageSize,
        });

    };

    const handleDownload = async () => {
        try {
            if (!cpdRenewalref.current) return;
            const formData = cpdRenewalref.current.getFormData();
            const downloadRequest = {
                ...paginationRequest,
                pageNo: 1,
                pageSize: paginationRequest.totalCount,
                searchText: formData.searchText || "",
                appilcationType: formData.appilcationType?.value || "",
                renewalCycle: formData.renewalCycle?.value || "",
                renewalApplicationAndPaymentStatus: formData.status?.value || "",
                qualificationEndDate: formData.qualificationEndDate?.value || "",
            };
            const response = await downloadSheetForrCPDRenewalCycle(downloadRequest);

            if (response && response.data) {
                const { fileData, fileName } = response.data;
                const blob = new Blob([fileData], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, fileName || "CPD-Renewal-Cycle.xlsx");
            }
        } catch (error) {
            console.error("Error downloading the file:", error);
        }
    };

    return (
        <>
            {allDropDownResponse ? <Suspense fallback={<DataLoader />}>
                <div>
                    <div className='row'>
                        <div className='current-cpd-cycle-point'>
                            <div className='row '>
                                <FormCreator 
                                    ref={cpdRenewalref} 
                                    {...cpdRenewalForm} 
                                />
                                <Buttons
                                    buttonText="Search"
                                    buttonTypeClassName="success-btn mt-4 ml-auto"
                                    onClick={handleSearch}
                                />
                                <Buttons
                                    buttonText="Clear"
                                    buttonTypeClassName="btn btn-dark mt-4 ml-auto"
                                    onClick={handleClear}
                                />
                            </div>
                            {isSearched && (
                                <div className="mt-3">
                                    <Buttons
                                        buttonText="Download Excel"
                                        buttonTypeClassName="success-btn"
                                        onClick={handleDownload}
                                    />
                                </div>)}

                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <h4>Total Count :{cpdRenewalCycleResponse?.totalCount}</h4>
                            <div className="table-responsive cpd-head-table">
                                <CpdRenewalCycleTable
                                    dataSource={dataSource}
                                    isLoading={isLoading}
                                    paginationRequest={paginationRequest}
                                    onPageChange={handlePageChange}
                                    getCpdRenewalCycleList={getCpdRenewalCycleList} />
                            </div>
                        </div>
                    </div>
                </div>
            </Suspense> : <DataLoader />}
        </>
    )
}

export default CpdRenewalCycleForm